import { getPropNames } from '@chakra-ui/styled-system';
import dayjs from 'dayjs';

import 'dayjs/locale/de';
import { theme } from '../theme';

dayjs.locale('de');

export const formatCurrency = (value: number) => value.toFixed(2).replace('.', ',');

export const formattedTaxedCurrency = (
	valueWithoutTaxes: number,
	vat: number,
	delimiter: string = '|',
) => `
  ${formatCurrency(valueWithoutTaxes)}€ Netto
  ${delimiter}
  ${formatCurrency(valueWithoutTaxes * ((100 + vat) / 100))}€ Brutto
`;

const containsTime = (dateString: string) => dateString.match(/\d{2}:\d{2}/g);

export const formatDateTime = (dateString: string) => {
	if (!dateString || !containsTime(dateString)) {
		throw new Error('dateString is required.');
	}

	const date = dayjs(dateString);

	if (!date.isValid()) {
		throw new Error(`Invalid dateString: ${dateString}`);
	}

	return date.format('DD.MM.YY HH:mm');
};

export const formatDate = (dateString: string | undefined): string | undefined => {
	if (!dateString) return;

	return dayjs(dateString).format('DD.MM.YYYY');
};

export const createId = (text: string) => text.replace(/[.,/#!$%^&*;:{}=\\\-_`~()\s?]/g, '');

export const formatPhoneNumber = (phoneNumber: string) =>
	`+49${phoneNumber.replace(/[\s-/]/g, '').slice(1)}`;

export const repeatFirstTimesN =
	(n: number) =>
	<T>(elements: T[]): T[] => {
		const [first, ...rest] = elements;
		return [...Array(n).fill(first), ...rest];
	};

export const clamp = (minPx: number, vw: number, maxPx: number, width: number): number => {
	const computedPx = (vw / 100) * width;
	if (computedPx < minPx) return minPx;
	else if (computedPx > maxPx) return maxPx;
	return computedPx;
};

export const removeTrailingSlash = (url: string): string => url.replace(/\/*$/g, '');

export const pluralizeIfRequired = (
	isSingular: boolean,
	singularText: string,
	pluralText?: string,
) => {
	if (isSingular) return singularText;

	if (pluralText) return pluralText;
	return `${singularText}e`;
};

export const normalizeOfficeName = (officeName: string) =>
	officeName.toLowerCase().replace(/[\s-]/g, '');

export const getEnvVarOrThrow = (name: string) => {
	const value = process.env[name];
	if (!value) throw Error(`Environment variable ${name} is not set.`);
	return value;
};

export function getCityFromLocation(location: string) {
	return location.split(' ').pop();
}
